import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { Button } from 'foundations-components/transitional/components/Button';
import { Text } from 'foundations-components/components/Text';
import { Select } from 'foundations-components/transitional/components/Select';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import I18n from 'I18n';
import { useMemo, useState } from 'react';
import AvailabilityIndicator from '../AvailabilityIndicator';
import { SelectableButton } from 'foundations-components/transitional/components/SelectableButton';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { NumberInput } from 'foundations-components/transitional/components/NumberInput';
import { Form } from 'foundations-components/transitional/components/Form';
import { AvailabilityValueComponent } from './AvailabilityValueComponent';
import { AVAILABLE, AWAY } from '../../../reassignment/constants/agent-state';
import { CUSTOM_TIME, calculateDurationMinutes } from '../../utils/statusModalUtils';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TIME_PRESETS = [15, 30, 45, 60];
const getStatusOptions = () => [{
  dropdownText: /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(AvailabilityIndicator, {
      isAwayMode: false,
      atCapacity: false
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "routing-ui.agent-status.statusModal.status.available"
    })]
  }),
  text: I18n.text('routing-ui.agent-status.statusModal.status.available'),
  value: AVAILABLE
}, {
  dropdownText: /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(AvailabilityIndicator, {
      isAwayMode: true,
      atCapacity: false
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "routing-ui.agent-status.statusModal.status.away"
    })]
  }),
  text: I18n.text('routing-ui.agent-status.statusModal.status.away'),
  value: AWAY
}];
export const ManageStatusModal = ({
  onCancel,
  onSave,
  // currentStatus,
  isSaving
}) => {
  const [formState, setFormState] = useState({
    customTime: undefined,
    status: AWAY,
    time: 30,
    isValid: true
  });
  const updateForm = update => {
    setFormState(Object.assign({}, formState, update));
  };
  const OPTIONS = useMemo(() => getStatusOptions(), []);
  const validateCustomTime = value => {
    if (formState.time !== CUSTOM_TIME) return true;
    if (value === undefined) return false;
    return value > 0 && value <= 90 && Number.isInteger(value);
  };
  const handleSubmit = e => {
    e.preventDefault();
    const durationMins = calculateDurationMinutes(formState);
    void onSave(formState.status, durationMins);
  };
  return /*#__PURE__*/_jsxs(Modal, {
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "routing-ui.agent-status.statusModal.title"
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onCancel
      })]
    }), /*#__PURE__*/_jsxs(Form, {
      onSubmit: handleSubmit,
      children: [/*#__PURE__*/_jsx(DialogBody, {
        children: /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          gap: "300",
          children: [/*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(Text, {
              as: "strong",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "routing-ui.agent-status.statusModal.status.label"
              })
            }), /*#__PURE__*/_jsx(Select, {
              value: formState.status,
              onChange: e => updateForm({
                status: e.target.value
              }),
              options: OPTIONS,
              valueComponent: AvailabilityValueComponent
            })]
          }), formState.status === AWAY && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(Text, {
              as: "strong",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "routing-ui.agent-status.statusModal.returnToAvailable.label"
              })
            }), /*#__PURE__*/_jsxs(Grid, {
              children: [TIME_PRESETS.map(time => /*#__PURE__*/_jsx(GridItem, {
                size: 6,
                marginBlock: "200",
                children: /*#__PURE__*/_jsx(SelectableButton, {
                  selected: formState.time === time,
                  onClick: () => {
                    updateForm({
                      time,
                      customTime: undefined,
                      isValid: true
                    });
                  },
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "routing-ui.agent-status.statusModal.returnToAvailable.timePreset",
                    options: {
                      time
                    }
                  })
                })
              }, time)), /*#__PURE__*/_jsx(GridItem, {
                size: 6,
                marginBlock: "200",
                children: /*#__PURE__*/_jsx(SelectableButton, {
                  selected: formState.time === CUSTOM_TIME,
                  onClick: () => {
                    updateForm({
                      time: CUSTOM_TIME,
                      isValid: false
                    });
                  },
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "routing-ui.agent-status.statusModal.returnToAvailable.custom"
                  })
                })
              })]
            }), formState.time === CUSTOM_TIME && /*#__PURE__*/_jsxs(Flex, {
              flexDirection: "column",
              gap: "200",
              children: [/*#__PURE__*/_jsx(Text, {
                as: "strong",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "routing-ui.agent-status.statusModal.returnToAvailable.customLabel"
                })
              }), /*#__PURE__*/_jsxs(Grid, {
                gap: "200",
                children: [/*#__PURE__*/_jsx(GridItem, {
                  size: 7,
                  children: /*#__PURE__*/_jsx(FormControl, {
                    error: formState.customTime !== undefined && !formState.isValid,
                    validationMessage: formState.customTime !== undefined && !formState.isValid && I18n.text('routing-ui.agent-status.statusModal.returnToAvailable.validationMessage'),
                    children: /*#__PURE__*/_jsx(NumberInput, {
                      value: formState.customTime,
                      precision: 0,
                      onChange: e => {
                        const newValue = e.target.value === '' ? undefined : Number(e.target.value);
                        updateForm({
                          customTime: newValue,
                          isValid: validateCustomTime(newValue)
                        });
                      }
                    })
                  })
                }), /*#__PURE__*/_jsx(GridItem, {
                  alignSelf: "center",
                  marginBlockEnd: !formState.isValid ? '900' : '0',
                  children: /*#__PURE__*/_jsx(Text, {
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "routing-ui.agent-status.statusModal.returnToAvailable.timeUnit"
                    })
                  })
                })]
              })]
            })]
          })]
        })
      }), /*#__PURE__*/_jsxs(DialogFooter, {
        children: [/*#__PURE__*/_jsx(LoadingButton, {
          use: "primary",
          type: "submit",
          disabled: !formState.isValid || isSaving,
          loading: isSaving,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "routing-ui.agent-status.statusModal.actions.save"
          })
        }), /*#__PURE__*/_jsx(Button, {
          onClick: onCancel,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "routing-ui.agent-status.statusModal.actions.cancel"
          })
        })]
      })]
    })]
  });
};
ManageStatusModal.displayName = 'ManageStatusModal';